module.exports = __webpack_public_path__ + "img/titlePc27-safeimagekit.8ce8bdc3.png";